import { useState } from 'react';

const allReviews = [
  {
    id: 1,
    name: '김○○ 님',
    location: '서울시',
    rating: 5,
    category: '보험 청구',
    date: '2025.11',
    img: 'https://cdn.imweb.me/thumbnail/20251206/bccf357889cde.jpg',
    text: '절차가 간단해서 너무 좋았습니다. 복잡할 줄 알았는데 한 번 설명 듣고 진행하니 간병인 연결부터 보험 처리까지 금방 끝났습니다. 특히 서류 챙길 필요 없이 보험이 접수된다는 게 제일 좋았어요.',
  },
  {
    id: 2,
    name: '이○○ 님',
    location: '인천시',
    rating: 5,
    category: '간병인 매칭',
    date: '2025.10',
    img: 'https://cdn.imweb.me/thumbnail/20251206/7f0588fbfdf89.jpg',
    text: '할머니가 입원하신 뒤 가족들이 돌아가며 간병했는데 너무 힘들었거든요. 코리아케어러스를 이용하면서 외부 도움을 처음 받아봤는데, 간병인 분도 성실하시고 전체적으로 믿을 수 있었어요.',
  },
  {
    id: 3,
    name: '박○○ 님',
    location: '대전시',
    rating: 5,
    category: '보험 청구',
    date: '2025.10',
    img: 'https://cdn.imweb.me/thumbnail/20251206/393b61e2c6111.jpg',
    text: '간병과 서류 걱정을 한꺼번에 덜었어요. 부모님 병간호와 회사 업무를 병행하기가 너무 힘들었는데, 이 서비스 덕분에 숨통이 트였어요. 간병인 매칭도 빠르고, 보험 청구는 자동으로 처리되어 따로 신경 쓸 게 없었습니다.',
  },
  {
    id: 4,
    name: '최○○ 님',
    location: '경기도 수원시',
    rating: 5,
    category: '전체 서비스',
    date: '2025.09',
    img: 'https://cdn.imweb.me/thumbnail/20251206/c99c50b23fd08.jpg',
    text: '일 때문에 병원에 오래 있지 못했는데, 간병인을 쉽게 연결해주고 보험 처리도 알아서 해줘서 정말 감사했어요. 예전엔 병원에서 퇴근하자마자 다시 서류 챙기러 다녔는데, 이번엔 그런 스트레스가 전혀 없었습니다.',
  },
  {
    id: 5,
    name: '정○○ 님',
    location: '광주시',
    rating: 5,
    category: '간병인 매칭',
    date: '2025.09',
    img: 'https://cdn.imweb.me/thumbnail/20251206/8328b92a2cb8b.jpg',
    text: '어머니가 입원하시고 급히 간병인을 구해야 했는데, 지인 소개로 이 서비스를 알게 됐어요. 연락하고 얼마 안 있어 간병인이 바로 오셨고, 덕분에 가족들 모두 돌아가면서 간병하던 부담이 줄었습니다.',
  },
  {
    id: 6,
    name: '강○○ 님',
    location: '부산시',
    rating: 5,
    category: '보험 청구',
    date: '2025.08',
    img: 'https://readdy.ai/api/search-image?query=friendly%20korean%20middle%20aged%20woman%20warm%20smile%20natural%20light%20portrait%20clean%20simple%20background%20soft%20tones%20professional%20photo&width=200&height=200&seq=review-p6&orientation=squarish',
    text: '보험이 이렇게 편하게 처리되는지 몰랐어요. 가입한 지 오래됐는데 한 번도 청구 못 했거든요. 코리아케어러스 덕분에 처음으로 간병비를 돌려받았습니다. 직원분이 처음부터 끝까지 꼼꼼하게 안내해주셨어요.',
  },
  {
    id: 7,
    name: '윤○○ 님',
    location: '대구시',
    rating: 5,
    category: '전체 서비스',
    date: '2025.08',
    img: 'https://readdy.ai/api/search-image?query=korean%20elderly%20man%20warm%20gentle%20expression%20natural%20light%20portrait%20soft%20neutral%20background%20comfortable%20attire&width=200&height=200&seq=review-p7&orientation=squarish',
    text: '나이가 들어서 그런지 혼자서 보험 청구하는 게 너무 어렵더라고요. 그런데 이 서비스는 모든 걸 대신해줘서 정말 편했어요. 간병인도 정말 친절하고 잘 돌봐주셨습니다. 주변 지인들에게 적극 추천하고 있어요.',
  },
  {
    id: 8,
    name: '한○○ 님',
    location: '울산시',
    rating: 5,
    category: '간병인 매칭',
    date: '2025.07',
    img: 'https://readdy.ai/api/search-image?query=korean%20woman%2040s%20friendly%20smile%20professional%20look%20natural%20portrait%20soft%20warm%20background%20clean%20simple&width=200&height=200&seq=review-p8&orientation=squarish',
    text: '아버지 수술 후 간병인이 급하게 필요해서 연락했는데 당일 바로 배정해주셨어요. 이런 서비스가 있는 줄 몰랐는데 정말 다행이었습니다. 간병인 선생님도 전문적이셔서 안심이 됐어요.',
  },
  {
    id: 9,
    name: '오○○ 님',
    location: '경기도 고양시',
    rating: 5,
    category: '보험 청구',
    date: '2025.07',
    img: 'https://readdy.ai/api/search-image?query=korean%20man%2050s%20calm%20gentle%20smile%20natural%20lighting%20portrait%20soft%20beige%20background%20neat%20appearance&width=200&height=200&seq=review-p9&orientation=squarish',
    text: '보험사에 직접 청구하려니 필요한 서류가 너무 많아서 막막했어요. 코리아케어러스에서 필요한 서류 목록도 다 알려주시고 어떻게 제출하는지까지 상세하게 안내해주셔서 어렵지 않게 청구할 수 있었습니다.',
  },
  {
    id: 10,
    name: '임○○ 님',
    location: '강원도 춘천시',
    rating: 5,
    category: '전체 서비스',
    date: '2025.06',
    img: 'https://readdy.ai/api/search-image?query=korean%20woman%2030s%20bright%20smile%20friendly%20portrait%20natural%20light%20clean%20neutral%20background%20professional%20photo&width=200&height=200&seq=review-p10&orientation=squarish',
    text: '처음에는 반신반의했는데 막상 이용해보니 너무 만족스러웠어요. 간병인 매칭부터 보험 청구까지 원스톱으로 처리해주니 정말 편리합니다. 다음에 또 필요하면 꼭 다시 이용할 거예요.',
  },
  {
    id: 11,
    name: '서○○ 님',
    location: '충청북도 청주시',
    rating: 5,
    category: '간병인 매칭',
    date: '2025.06',
    img: 'https://readdy.ai/api/search-image?query=kind%20korean%20elderly%20woman%20warm%20smile%20natural%20light%20portrait%20soft%20light%20background%20comfortable%20casual&width=200&height=200&seq=review-p11&orientation=squarish',
    text: '남편 입원 기간 동안 출근을 계속해야 해서 너무 걱정이었는데 코리아케어러스 덕분에 마음 놓고 일할 수 있었어요. 간병인 선생님이 남편을 정말 친자식처럼 돌봐주셨습니다.',
  },
  {
    id: 12,
    name: '장○○ 님',
    location: '제주시',
    rating: 4,
    category: '보험 청구',
    date: '2025.05',
    img: 'https://readdy.ai/api/search-image?query=korean%20man%2060s%20gentle%20expression%20natural%20portrait%20warm%20neutral%20background%20soft%20lighting%20relaxed%20pose&width=200&height=200&seq=review-p12&orientation=squarish',
    text: '처음엔 보험 청구가 복잡할 줄 알았는데 담당자분이 차근차근 설명해주셔서 잘 마무리됐어요. 간병 기간도 길었는데 꼼꼼하게 처리해주셨습니다. 서비스가 전반적으로 좋았어요.',
  },
];

const categories = ['전체', '간병인 매칭', '보험 청구', '전체 서비스'];

export default function ReviewGrid() {
  const [activeCategory, setActiveCategory] = useState('전체');
  const [showAll, setShowAll] = useState(false);

  const filtered = activeCategory === '전체'
    ? allReviews
    : allReviews.filter((r) => r.category === activeCategory);

  const displayed = showAll ? filtered : filtered.slice(0, 6);

  return (
    <section className="w-full py-16" style={{ backgroundColor: '#f9fdfb' }}>
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
          <div>
            <p className="text-xs font-semibold tracking-widest uppercase mb-2" style={{ color: '#2E7D6B' }}>ALL REVIEWS</p>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900">전체 고객 후기</h2>
          </div>
          {/* Category Filter */}
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => { setActiveCategory(cat); setShowAll(false); }}
                className="px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all"
                style={{
                  backgroundColor: activeCategory === cat ? '#2E7D6B' : '#fff',
                  color: activeCategory === cat ? '#fff' : '#6b7280',
                  border: activeCategory === cat ? '1.5px solid #2E7D6B' : '1.5px solid #e5e7eb',
                }}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Review Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {displayed.map((review) => (
            <ReviewCard key={review.id} review={review} />
          ))}
        </div>

        {/* Load More */}
        {!showAll && filtered.length > 6 && (
          <div className="flex justify-center mt-10">
            <button
              onClick={() => setShowAll(true)}
              className="px-8 py-3 rounded-lg border font-semibold text-sm cursor-pointer transition-all hover:bg-[#2E7D6B] hover:text-white hover:border-[#2E7D6B]"
              style={{ borderColor: '#2E7D6B', color: '#2E7D6B' }}
            >
              후기 더보기 <i className="ri-arrow-down-s-line ml-1"></i>
            </button>
          </div>
        )}
        {showAll && filtered.length > 6 && (
          <div className="flex justify-center mt-10">
            <button
              onClick={() => setShowAll(false)}
              className="px-8 py-3 rounded-lg border font-semibold text-sm cursor-pointer transition-all"
              style={{ borderColor: '#d1d5db', color: '#6b7280' }}
            >
              접기 <i className="ri-arrow-up-s-line ml-1"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

interface ReviewCardProps {
  review: typeof allReviews[0];
}

function ReviewCard({ review }: ReviewCardProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="bg-white rounded-2xl overflow-hidden border border-gray-100 flex flex-col transition-all hover:-translate-y-0.5">
      <div className="w-full h-44 overflow-hidden">
        <img src={review.img} alt={`${review.name} 후기`} className="w-full h-full object-cover object-top" />
      </div>
      <div className="p-5 flex-1 flex flex-col">
        {/* Meta */}
        <div className="flex items-start justify-between mb-3 gap-2">
          <div>
            <p className="text-sm font-bold text-gray-900">{review.name}</p>
            <p className="text-xs text-gray-400 flex items-center gap-1 mt-0.5">
              <i className="ri-map-pin-2-line text-xs" style={{ color: '#2E7D6B' }}></i>
              {review.location}
              <span className="text-gray-300 mx-1">·</span>
              {review.date}
            </p>
          </div>
          <div className="flex flex-col items-end gap-1">
            <div className="flex gap-0.5">
              {Array.from({ length: 5 }).map((_, si) => (
                <i key={si} className={`ri-star-fill text-xs ${si < review.rating ? 'text-yellow-400' : 'text-gray-200'}`}></i>
              ))}
            </div>
            <span
              className="text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap"
              style={{ backgroundColor: '#e8f5f1', color: '#2E7D6B' }}
            >
              {review.category}
            </span>
          </div>
        </div>
        {/* Text */}
        <p className={`text-sm text-gray-600 leading-relaxed flex-1 ${!expanded ? 'line-clamp-3' : ''}`}>
          {review.text}
        </p>
        {review.text.length > 80 && (
          <button
            onClick={() => setExpanded(!expanded)}
            className="text-xs mt-2 cursor-pointer font-medium self-start"
            style={{ color: '#2E7D6B' }}
          >
            {expanded ? '접기' : '더보기'}
          </button>
        )}
      </div>
    </div>
  );
}
